'use strict';

import Events from "../tracker/events";
import PreLoader from '../../modules/preloader';
import Trackers from '../tracker/tracker';

require('./impromptu');
require('./../mini-cart.js');
require('./../data-layer-cart.js');

const event = new Events();

let Basket = require('../cart/cart');

jQuery(function() {
    const trackers = new Trackers();
    //закрытие popup окна по клику на кнопку вернуться к покупкам
    $('body').on('click', 'button.js-close-btn', function(e) {
        e.preventDefault();
        $.prompt.close();
    });

    //Кнопка добавить в корзину
    $('body').on('click', '.js-add-2-cart', function(e) {
        e.preventDefault();
        var iQuantity = $('input[name="product_quantity"]').val();

        trackers.getTracker('gtm').onAddToCart();

        if (!$.isNumeric(iQuantity)) {
            iQuantity = 1;
        }
        var productId = $(this).data('product-id');
        var $this = $(this);
        var data = {
            product_id: productId,
            quantity: iQuantity
        };

        let product_name = $this.parent().parent().find('.product__name').data('name');

        $.ajax({
            url: '/ajax/action/basket_add_popup/add_to_basket_without_popup/',
            data: data,
            success: function(result) {
                $this.removeClass('js-add-2-cart');
                $this.text(result.data.BUTTON_TEXT.toUpperCase());
                if ($this.hasClass('product-card__btn')) {
                    $this.attr('href', result.data.PATH_TO_BASKET);
                    $('.js-product-quantity').hide();
                }

                if ($this.hasClass('product-detail__action-btn')) {
                    $this.attr('href', result.data.PATH_TO_BASKET);
                }

                if ($this.hasClass('product__btn')) {
                    $this.removeClass('product__btn-buy');
                    $this.addClass('product__btn-detail');
                    $this.addClass('js-go-to-basket');
                    $this.attr('data-href', result.data.PATH_TO_BASKET);
                }

                window.smartBuyTracker.basketItemAdded({ id: productId });
                trackers.onPMbtnAddToCart({ param: product_name });
                window.updateMiniBasket();
                window.pushNewCartItem(productId, iQuantity);

                // кидает ошибку, пока закоментим
                //event.onAddToCardProduct($this);
            }
        });
    });

    //Кнопка добавить в корзину в шаблоне Протокол
    $('body').on('click', '.js-add-2-cart--protocol', function(e) {
        e.preventDefault();
        var iQuantity = $('input[name="product_quantity"]').val();

        trackers.getTracker('gtm').onAddToCart();

        if (!$.isNumeric(iQuantity)) {
            iQuantity = 1;
        }
        let productId = $(this).data('product-id');

        let productIds = [];
        if (productId.length) {
            productIds = productId.split(',');
        } else {
            productIds.push(productId);
        }

        var $this = $(this);
        $.each(productIds, function( key, value ) {
            var data = {
                product_id: value,
                quantity: iQuantity
            };

            let product_name = $this.parent().parent().find('.product__name').data('name');

            $.ajax({
                url: '/ajax/action/basket_add_popup/add_to_basket_without_popup/',
                data: data,
                success: function(result) {
                    if ($this.hasClass('product-card__btn')) {
                        $this.attr('href', result.data.PATH_TO_BASKET);
                        $('.js-product-quantity').hide();
                    }
                    if ($this.hasClass('product__btn')) {
                        $this.removeClass('product__btn-buy');
                        $this.addClass('product__btn-detail');
                        $this.addClass('js-go-to-basket');
                        $this.attr('data-href', result.data.PATH_TO_BASKET);
                    }

                    trackers.onPMbtnAddToCart({param:product_name});
                    window.updateMiniBasket();
                    window.smartBuyTracker.basketItemAdded({ id: productId });
                }
            });
        });
        $this.removeClass('js-add-2-cart');
        $this.text('В корзине');
        event.onAddToCardProduct($this);
    });

    //Кнопка комплексной покупки
    $('body').on('click', '.js-complex-buy', function(e) {
        e.preventDefault();
        $.ajax({
            url:
                '/ajax/component/maximaster:basket.add.popup/complex/?POPUP=Y&COMPLEX=Y&PRODUCT_ID=' +
                $(this).data('product-id'),
            success: function(result) {
                $.prompt(result.html, {
                    buttons: {},
                    persistent: false, //чтобы можно было закрыть при клике по оверлею
                    classes: {
                        prompt: 'prompt--large',
                        form: 'prompt__form-special',
                        close: 'jqiclose--cross'
                    },
                    submit: function(e) {
                        e.preventDefault();
                        window.updateMiniBasket();
                    }
                });
            }
        });
    });

    //Добавление в корзину при изменинии кол-ва в инпуте
    $('body').on('change', 'input.js-quantity-input-basket', function() {
        let basket = new Basket();
        basket.updateProductQuantity($(this).data('product-id'), $(this).val(), $(this).data('parent-product-id'));
    });

    //Добавление в корзину при изменении кол-ва кнопками
    $('body').on('click', '.quantity__btn', function() {
        if ($(this).hasClass('js-quantity-minus-basket') || $(this).hasClass('js-quantity-plus-basket')) {
            var iQuantity = $('input[name="QUANTITY_' + $(this).data('product-id') + '"]').val();
            if ($(this).hasClass('js-quantity-plus')) {
                iQuantity++;
            } else if ($(this).hasClass('js-quantity-minus') && iQuantity > 0) {
                iQuantity--;
            }
            let basket = new Basket();
            basket.updateProductQuantity($(this).data('product-id'), iQuantity, $(this).data('parent-product-id'));
        }
    });

    //Кнопка уведомить при поступлении товара
    $(document).on('click', '.js-cart-inform', function(e) {
        e.preventDefault();
        $.ajax({
            url: '/ajax/component/maximaster:element.arrival.inform/.default/',
            data: {
                ELEMENT_ID: $(this).data('product-id')
            },
            success: function(result) {
                $.prompt(result.html, {
                    buttons: {},
                    persistent: false, //чтобы можно было закрыть при клике по оверлею
                    classes: {
                        prompt: 'prompt--large',
                        form: 'prompt__form-special',
                        close: 'jqiclose--cross'
                    },
                    submit: function(e) {
                        e.preventDefault();
                        $.ajax({
                            url: '/ajax/action/element_arrival_inform/add_to_sch_list/',
                            data: $('form.jqiform').serialize(),
                            success: function(result) {
                                $('#subscribe__content').html(result.html);
                            }
                        });
                    }
                });
            }
        });
    });

    $('.js-beautician-price-request-tooltip').tooltipster({
        content: $('.js-beautician-price-request-tooltip-content').html(),
        interactive: true,
        contentAsHTML: true,
        position: 'bottom',
        maxWidth: 320,
        minWidth: 320,

        repositionOnScroll: true,
        side: ['bottom', 'top'],
        trigger: 'custom',
        triggerOpen: {
            mouseenter: true,
            tap: true
        },
        triggerClose: {
            mouseleave: true,
            tap: true
        },
        updateAnimation: null
    });

    $(document).on('click', '.js-beautician-price-request', function(e) {
        e.preventDefault();
        $.ajax({
            url: '/ajax/component/maximaster:widget.beautician.price.request/.default/',
            data: {
                ELEMENT_ID: $(this).data('product-id')
            },
            success: function(result) {
                $('.js-beautician-price-request-tooltip').tooltipster('hide');
                $.prompt(result.html, {
                    buttons: {},
                    persistent: true, //чтобы можно было закрыть при клике по оверлею
                    classes: {
                        form: 'beautician-price-request-form'
                    },
                    submit: function(e, v, m, form) {
                        e.preventDefault();

                        let preLoader = new PreLoader();
                        preLoader.show();

                        let files = $('.js-attach-file-input-controll')[0].files;
                        let formData = new FormData();
                        for (let name in form) {
                            formData.append(name, form[name]);
                        }

                        for (let k = 0; k <= files.length; k++) {
                            if (files[k]) {
                                formData.append('ATTACH_FILES[]', files[k]);
                            }
                        }

                        $.ajax({
                            url: '/ajax/action/widget_beautician_price_request/submit_form/',
                            data: formData,
                            processData: false,
                            contentType: false,
                            type: 'POST',
                            cache: false,
                            success: function (response) {
                                preLoader.hide();
                                if (response['code'] === 400) {
                                    $('.js-beautician-price-request-error').html(response.message);
                                    return;
                                }
                                $('.js-beautician-price-request-container').html(response.html);
                            }
                        });
                    }
                });
            }
        });
    });

    $(document).on('click', '.js-btn-detail', function(e) {
        e.preventDefault();
        let element = e.target;
        window.location = element.getAttribute('data-href');
    });

    $(document).on('click', '.js-go-to-basket', function(e) {
        e.preventDefault();
        let element = e.target;
        window.location = element.getAttribute('data-href');
    });

    $(document).on('click', '.js-close-window', function(e) {
        e.preventDefault();
        $.prompt.close();
    });
});



// WEBPACK FOOTER //
// ./blocks/impromptu/impromptu-add2cart.js